/* eslint-disable @typescript-eslint/ban-ts-comment */
/* eslint-disable @typescript-eslint/restrict-template-expressions */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/strict-boolean-expressions */
import React, { useEffect, useState } from 'react';
import CustomDataTable from '../CustomDataTable/CustomDataTable';
import { updatestatus, getAlltemplate, deletetemplate, copytemplate, submitapproval } from 'src/services/templateService';
import { Autocomplete, IconButton, Menu, MenuItem, TextField, TextareaAutosize } from '@mui/material';
import type { TableColumn } from 'react-data-table-component';
import MUIModal from '../MUIModal/MUIModal';
import AddTemplateForm from './AddTemplateForm';
import GradientButton from '../MUICustomButton/GradientButton';
//@ts-ignore
import { HugeiconsIcon } from '@hugeicons/react';
//@ts-ignore
import { MoreVerticalSolidRounded } from '@hugeicons-pro/core-solid-rounded';
//@ts-ignore
import { MultiplicationSignStrokeStandard } from '@hugeicons-pro/core-stroke-standard';
//@ts-ignore
import { ArrowDown01Icon } from '@hugeicons-pro/core-stroke-standard';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import { styled } from '@mui/material/styles';
import { ARE_YOU_SURE, DELETE_TEMPLATE, ACTIVATE_TEMPLATE_SUCCESS_MESSAGE, COPY_TEMPLATE_SUCCESS_MESSAGE, DEACTIVATE_TEMPLATE_SUCCESS_MESSAGE, DELETE_TEMPLATE_SUCCESS_MESSAGE, COPY_TEMPLATE } from 'src/constants/constant';
import OutlineButton from '../MUICustomButton/OutlineButton';
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { NotificationManager } from 'react-notifications';
import { useSelector } from 'react-redux';
import type { appConfigs, RootState } from '../types/types';
import { FormControl } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { Link } from 'react-router-dom'
//@ts-ignore
import { ViewStrokeRounded, Image03Icon, PencilEdit02Icon } from '@hugeicons-pro/core-stroke-rounded';
import TemplatePreview from '../TemplatePreview/TemplatePreview'; // Import your modal component
import type { TooltipProps } from '@mui/material/Tooltip';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import { checkEventPermission } from "../../common/utility/utility";

const BootstrapTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} arrow classes={{ popper: className }} placement="bottom" />
))(({ theme }) => ({
  [`& .${tooltipClasses.arrow}`]: {
    color: theme.palette.common.black,
  },
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.palette.common.black,
  },
}));

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
}));

const ITEM_HEIGHT = 48;

interface TemplateListPropType {
  id: number;
  litmusId?: number;
  parentId?: number;
  createdBy?: number;
  clientId?: number;
  templateName: string;
  templateContent: string;
  subjectLine: string;
  fromName: string;
  fromEmail: string;
  preheader: string;
  resendSubjectLine: string;
  resendPreheader: string;
  status: number;
  statusName?: string;
  templateIdentifier?: string;
}

interface ApiResponse {
  status: number;
  data: {
    data: TemplateListPropType[];
    result: number;
  };
}


const TemplateList: React.FC = () => {

  const [templateListData, setTemplateListData] = useState<TemplateListPropType[]>([])
  const [templateSearchData, setTemplateSearchData] = useState<TemplateListPropType[]>([])
  const [openAddTemplateModal, setOpenAddTemplateModal] = useState<boolean>(false)
  const [loading, setLoading] = useState<boolean>(true)
  const [isModalSaveLoading, setIsModalSaveLoading] = useState<boolean>(false)
  const [templateInfoData, setTemplateInfoData] = useState<any>();
  const [showDeleteTemplateModal, setDeleteTemplateModal] = useState<boolean>(false);
  const [showDeactivateTemplateModal, setDeactivateTemplateModal] = useState<boolean>(false);
  const [showSubmitForApprovalModal, setSubmitForApprovalModal] = useState<boolean>(false);
  const [showCopyTemplateModal, setCopyTemplateModal] = useState<boolean>(false);
  const [selectedValue, setSelectedValue] = useState<any>({ value: "", label: "Select Status" })
  const [isPreviewModalOpen, setIsPreviewModalOpen] = useState(false);
  const [previewContent, setPreviewContent] = useState('');
  const storedAppConfig = localStorage.getItem("appConfigs");
  const [submitmessage, setSubmitMessage] = useState('');
  const [validationError, setValidationError] = useState('');
  const [warningMessage, setWarningMessage] = useState<string>('');
  const [showConfirmModal, setShowConfirmModal] = useState(false);


  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const [anchorActionEl, setAnchorActionEl] = React.useState<any>({});
  const { user } = useSelector((state: RootState) => state.auth);

  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  const userData = JSON.parse(localStorage.getItem("user"));
  console.log(userData);
  const RoleId = userData !== null ? userData.roleID : 0;
  console.log(RoleId);
  const navigate = useNavigate()

  useEffect(() => {
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    getTemplateListData()
  }, [user])

  const getTemplateListData = (): void => {
    setLoading(true)
    const ClientId = user?.clientId ?? 0;
    getAlltemplate(ClientId)
      .then(
        (res: ApiResponse) => {
          if (res.status === 200) {
            if (res.data.result === 1) {
              const templateArr: TemplateListPropType[] = [];
              res.data.data.map((template: any) => {
                template.Name = `${template.templateName}`
                templateArr.push(template)
              })
              setTemplateListData(templateArr)
              setTemplateSearchData(templateArr)
            } else {
              setTemplateListData([])
              setTemplateSearchData([])
            }

          }
        }
      )
      .catch(
        (error: any) => console.log("Error: ", error)
      )
      .finally(() => {
        setLoading(false)
      })
  }

  const handleAddTemplateClick = (): void => {
    navigate('/template/new-template')
  }

  const handleCloseAddTemplateModal = (): void => {
    setOpenAddTemplateModal(false)
  }

  const handleActionClick = (event: React.MouseEvent<HTMLElement>, id: number): void => {
    // anchorActionEl[id] = event.currentTarget
    setAnchorActionEl({ ...anchorActionEl, [id]: event.currentTarget });
  }

  const handleSearch = (e: React.ChangeEvent<HTMLInputElement>): void => {
    const value = e.target.value.trim();
    let templateDataArr = [...templateListData]
    if (value !== "") {
      // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions, @typescript-eslint/prefer-optional-chain
      templateDataArr = templateDataArr && templateDataArr.filter((template: TemplateListPropType) => {
        return template.templateName.toLowerCase().search(value.toLowerCase()) >= 0
      })
    }
    setTemplateSearchData(templateDataArr)
  }

  const handleDeleteTemplate = (id: number, templateName: string): void => {
    setTemplateInfoData({ id, templateName });
    setDeleteTemplateModal(true)
    setAnchorActionEl(null);
    setAnchorActionEl({ ...anchorActionEl, [id]: null });
  }

  const handleDeleteTemplateClose = (): void => {
    setDeleteTemplateModal(false)
  }

  const handleDeleteTemplateConfirm = (): void => {
    setIsModalSaveLoading(true)

    const { id } = templateInfoData;

    const data = {
      "deletedBy": userData.id,
      "tempList": [
        {
          "templateId": id
        }
      ],
    }

    deletetemplate(data)
      .then(
        (res: ApiResponse) => {
          if (res.status === 200) {
            if (res.data.result === 1) {
              NotificationManager.success(DELETE_TEMPLATE_SUCCESS_MESSAGE, '', 5000);
              setDeleteTemplateModal(false)
              getTemplateListData()
            }
          }
        }
      )
      .catch((error: any) => console.log("Error", error))
      .finally(() => setIsModalSaveLoading(false))
  }

  const handleupdatestatus = (id: number, statusId: number, templateName: string): void => {
    // Determine the new status based on the current `statusId`
    let newStatus: number | null = null;
    if (statusId === 1) {
      newStatus = 2; // If Approved, action is Reject
    } else if (statusId === 2) {
      newStatus = 1; // If Rejected, action is Approve
    }

    setTemplateInfoData({ id: id, newStatus: newStatus, templateName: templateName });

    // Trigger the modal and close any open action menus
    setDeactivateTemplateModal(true);
    setAnchorActionEl(null);
    setAnchorActionEl({ ...anchorActionEl, [id]: null });
  };

  const handleupdatestatusClose = (): void => {
    setDeactivateTemplateModal(false)
    setValidationError('');
    setWarningMessage('');
    setSubmitMessage('');
  }

  const handleUpdateStatusConfirm = (): void => {
    if (!submitmessage.trim()) {
      if (templateInfoData?.newStatus === 1) {
        setShowConfirmModal(true);
        return;
      } else {
        setValidationError("Please provide a reason for rejection.");
        return;
      }
    }
    proceedWithSubmission();
  };

  const proceedWithSubmission = (): void => {
    setShowConfirmModal(false);
    setIsModalSaveLoading(true);

    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    const userData = JSON.parse(localStorage.getItem("user"))
    const { id, newStatus } = templateInfoData;

    const data = {
      "updatedBy": userData.id,
      "id": id,
      "status": (templateInfoData?.newStatus == 1) ? 1 : 2,
      "message": submitmessage ? submitmessage : null
    }

    updatestatus(data)
      .then((res: ApiResponse) => {
        if (res.status === 200 && res.data.result === 1) {
          NotificationManager.success(newStatus === 1 ? ACTIVATE_TEMPLATE_SUCCESS_MESSAGE : DEACTIVATE_TEMPLATE_SUCCESS_MESSAGE, "", 5000);
          setDeactivateTemplateModal(false);
          setSubmitMessage("");
          getTemplateListData();
        }
      })
      .catch((error) => console.log("Error", error))
      .finally(() => setIsModalSaveLoading(false));
  };

  const handleSubmitForApproval = (id: number, templateName: string): void => {
    setTemplateInfoData({ id: id, newStatus: 1, templateName: templateName });

    // Trigger the modal and close any open action menus
    setSubmitForApprovalModal(true);
    setAnchorActionEl(null);
    setAnchorActionEl({ ...anchorActionEl, [id]: null });
  };

  const handleSubmitForApprovalClose = (): void => {
    setSubmitForApprovalModal(false)
    setValidationError('');
    setWarningMessage('');
    setSubmitMessage('');
  }

  const handleSubmitForApprovalConfirm = (): void => {
    setIsModalSaveLoading(true)

    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    const userData = JSON.parse(localStorage.getItem("user"))
    const { id } = templateInfoData;

    submitapproval(id, userData.id)
      .then(
        (res: ApiResponse) => {
          if (res.status === 200) {
            if (res.data.result === 1) {
              NotificationManager.success("Template sent for approval", '', 5000);
              setSubmitForApprovalModal(false)
              getTemplateListData()
            }
          }
        }
      )
      .catch((error: any) => console.log("Error", error))
      .finally(() => setIsModalSaveLoading(false))
  }

  const handleCopyTemplate = (id: number, templateName: string): void => {
    setTemplateInfoData({ id, templateName });
    setCopyTemplateModal(true)
    setAnchorActionEl(null);
    setAnchorActionEl({ ...anchorActionEl, [id]: null });
  }

  const handleCopyTemplateClose = (): void => {
    setCopyTemplateModal(false)
  }

  const handleCopyTemplateConfirm = (): void => {
    setIsModalSaveLoading(true)

    const { id } = templateInfoData;

    copytemplate(id, userData.id)
      .then(
        (res: ApiResponse) => {
          if (res.status === 200) {
            if (res.data.result === 1) {
              NotificationManager.success(COPY_TEMPLATE_SUCCESS_MESSAGE, '', 5000);
              setCopyTemplateModal(false)
              getTemplateListData()
            }
          }
        }
      )
      .catch((error: any) => console.log("Error", error))
      .finally(() => setIsModalSaveLoading(false))
  }

  const handleTemplateValue = (newValue: { value: string; label: string } | null): void => {
    if (newValue) {
      setSelectedValue(newValue); // Update state with the selected value

      // Filter data based on the selected value
      let filteredTemplateData = [...templateListData];
      if (newValue.value !== '10') {
        filteredTemplateData = filteredTemplateData.filter(
          (item) => String(item.status) === newValue.value // Ensure both are strings for comparison
        );
      }

      setTemplateSearchData(filteredTemplateData); // Update state with filtered data
    } else {
      // Reset to default state when no value is selected
      setSelectedValue({ value: '', label: 'Select Status' });
      setTemplateSearchData([...templateListData]); // Reset to full list
    }
  };
  const handleEditNavigation = (id: number): void => {
    navigate(`/template/edit-template/edit/${id}`);
  }
  // Dropdown options
  const options = [
    // { value: '10', label: 'All' },          // Use '10' as the identifier for all data
    { value: '1', label: 'Approved' },
    { value: '2', label: 'Rejected' },
    { value: '3', label: 'In Progress' },
    { value: '4', label: 'Pending' },
  ];

  const columns: TableColumn<TemplateListPropType>[] = [
    {
      name: 'Preview',
      cell: (row: TemplateListPropType) => {
        let imageUrl: string | null = null;

        if (storedAppConfig != null) {
          try {
            const parsedAppConfig = JSON.parse(storedAppConfig) as appConfigs[];
            const TemplateImagePublicURL = parsedAppConfig.find(
              (item) => item.configName === "TemplateImagePublicURL"
            )?.configValue;
            if (TemplateImagePublicURL != '') {
              imageUrl = `${TemplateImagePublicURL}Template/${row.templateIdentifier}/Template_Short.png`;
            }
          } catch (error) {
            console.error("Error parsing appConfig data:", error);
          }
        }

        return (
          <div className="relative w-[90px] h-[90px] flex items-center justify-center" onClick={(row.templateContent !== "") ? () => {
            setPreviewContent(row.templateContent);
            setIsPreviewModalOpen(true);
          } : undefined}>
            {(imageUrl != null) ? (
              <img
                src={imageUrl}
                width={90}
                height={90}
                alt="Preview"
                className="icon-hover"
                onError={(e) => {
                  e.currentTarget.style.display = 'none'; // Hide broken image
                  const iconElement = e.currentTarget.nextElementSibling as HTMLElement;
                  // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
                  if (iconElement) iconElement.style.display = 'flex'; // Show icon
                }}
                style={{ borderRadius: '8px', objectFit: 'cover' }}
              />
            ) : null}
            <HugeiconsIcon
              icon={Image03Icon}
              size={24}
              color="#3a3a3a"
              className="hidden" // Initially hidden, shown if image fails
            />
            <div
              className="absolute inset-0 flex items-center justify-center bg-black bg-opacity-50 opacity-0 rounded-lg hover:opacity-100 transition-opacity cursor-pointer"
            >
              <HugeiconsIcon
                icon={ViewStrokeRounded}
                size={24}
                color="white"
                strokeWidth={0.5}
                className={`cursor-pointer ${(row.templateContent === "") ? 'opacity-50 cursor-not-allowed' : ''}`}
              />
            </div>
          </div>
        );
      },
      width: '10%',
      sortable: false
    },
    {
      name: 'Template',
      selector: (row: TemplateListPropType) => row.templateName,
      cell: (row: any) => {
        return (
          <div className="flex py-4 first:pt-0 last:pb-0" style={{ width: '100%' }}>
            <div className="overflow-hidden" style={{ width: '100%' }}>
              <p
                className="text-14 font-semibold underline leading-[22px] cursor-pointer text-muted"
                onClick={() => handleEditNavigation(row.id)}
                title="Click to edit"
              >
                {row.templateName}
              </p>
              <p className="text-14 text-muted">
                <span className='font-semibold'>ID:</span> {row.id}
              </p>
            </div>
          </div>
        );
      },
      width: '14%',
      sortable: true
    },
    {
      name: 'From Name',
      selector: (row: TemplateListPropType) => row.fromName,
      width: '14%',
      sortable: true
    },
    {
      name: 'From Email',
      selector: (row: TemplateListPropType) => row.fromEmail,
      width: '14%',
      sortable: true
    },
    {
      name: 'Subject',
      selector: (row: TemplateListPropType) => row.subjectLine,
      width: '20%',
      sortable: true
    },

    {
      name: 'Status',
      sortable: false,
      width: "15%",
      cell: (row: TemplateListPropType) => {
        if (row.status == 4) {
          return (
            <div className="badge truncate" style={{ background: '#D9DBF9', padding: '10px 15px', color: '#191975', border: '0px', }}>Pending approval</div>
          );
        }
        if (row.status == 3) {
          return (
            <div className="badge truncate" style={{ background: '#FFF2C2', padding: '10px 15px', color: '#FF7A00', border: '0px', }}>In progress</div>
          );
        }
        if (row.status == 2) {
          return (
            <div className="badge truncate" style={{ background: '#FFF5F6', padding: '10px 15px', color: '#F13139', border: '0px', }}>Rejected</div>
          );
        }
        if (row.status == 1) {
          return (
            <div className="badge truncate" style={{ background: '#CCFFEA', padding: '10px 15px', color: '#06A864', border: '0px', }}>Approved</div>
          );
        }
        return <div></div>;
      },
    },
    {
      name: 'Actions',
      cell: (row: TemplateListPropType) => {
        console.log("anchorActionEl", anchorActionEl)
        return (
          <div className='flex items-center'>
            <div className="icon-hover-container">
              <Link
                to={{ pathname: `/template/edit-template/edit/${row.id}` }}
                state={{ clientData: row }}
                style={{ width: "20px" }}
              >
                <HugeiconsIcon
                  icon={PencilEdit02Icon}
                  size={20}
                  color="#3A3A3A"
                  strokeWidth={0.2}
                />
              </Link>
            </div>
            <div className='flex'>
              {(checkEventPermission('TEMPLATE_APPROVE') ||
                (checkEventPermission('TEMPLATE_SUB_APPROVE') && row.status === 3) ||
                checkEventPermission('TEMPLATE_DUPLICATE') || checkEventPermission('TEMPLATE_DELETE')) && (
                  <>
                    <IconButton
                      aria-label="more"
                      id="long-button"
                      // aria-controls={open ? 'long-menu' : undefined}
                      // aria-expanded={open ? 'true' : undefined}
                      aria-haspopup="true"
                      onClick={(e) => handleActionClick(e, row.id)}
                    >

                      <HugeiconsIcon
                        icon={MoreVerticalSolidRounded}
                        size={20}
                        color="#3A3A3A"
                        strokeWidth={0.2}
                      />

                    </IconButton>
                    <Menu
                      id={`${row.id}`}
                      className='table-action-menu'
                      MenuListProps={{
                        'aria-labelledby': 'long-button',
                      }}
                      anchorEl={anchorActionEl[row.id]}
                      open={Boolean(anchorActionEl[row.id])}
                      onClose={() => setAnchorActionEl({ ...anchorActionEl, [row.id]: null })}
                      PaperProps={{
                        style: {
                          maxHeight: ITEM_HEIGHT * 4.5,
                          width: '20ch',
                          // maxWidth: 'fit-content'
                        },
                      }}
                    >
                      {/* If RoleId is 1, show Approve/Reject options */}
                      {checkEventPermission('TEMPLATE_APPROVE') && (
                        <>
                          {row.status == 1 && (
                            <MenuItem onClick={() => handleupdatestatus(row.id, row.status, row.templateName)}>
                              <span  className="text-muted font-normal">Reject</span>
                            </MenuItem>
                          )}

                          {row.status == 2 && (
                            <MenuItem onClick={() => handleupdatestatus(row.id, row.status, row.templateName)}>
                              <span  className="text-muted font-normal">Approve</span>
                            </MenuItem>
                          )}

                          {row.status === 4 && (
                            <>
                              <MenuItem onClick={() => handleupdatestatus(row.id, 2, row.templateName)}>
                                <span  className="text-muted font-normal">Approve</span>
                              </MenuItem>
                              <MenuItem onClick={() => handleupdatestatus(row.id, 1, row.templateName)}>
                                <span  className="text-muted font-normal">Reject</span>
                              </MenuItem>
                            </>
                          )}
                        </>
                      )}
                      {/* If status is in in progress , show "Submit for Approval" option */}
                      {checkEventPermission('TEMPLATE_SUB_APPROVE') && row.status == 3 && (
                        <MenuItem onClick={() => handleSubmitForApproval(row.id, row.templateName)}>
                          <span  className="text-muted font-normal">Submit for Approval</span>
                        </MenuItem>
                      )}
                      {checkEventPermission('TEMPLATE_DUPLICATE') &&
                        <MenuItem onClick={() => handleCopyTemplate(row.id, row.templateName)}>
                          <span  className='text-muted font-normal'>Duplicate</span>
                        </MenuItem>
                      }
                      {checkEventPermission('TEMPLATE_DELETE') &&
                        <BootstrapTooltip title={row.statusName === 'Approved' ? "Cannot delete an approved template" : ""} arrow disableHoverListener={row.statusName !== 'Approved'}>
                          <span>
                            <MenuItem onClick={() => handleDeleteTemplate(row.id, row.templateName)} disabled={row.statusName === 'Approved'}>
                              <span style={{ cursor: row.statusName !== 'Approved' ? 'pointer' : 'not-allowed', color: row.statusName === 'Approved' ? '#A0A0A0' : '#F13139' }}>Delete</span>
                            </MenuItem>
                          </span>
                        </BootstrapTooltip>
                      }
                    </Menu>
                  </>
                )
              }
            </div>

          </div>
        )
      },
      // width: '8%',
      style: {justifyContent: 'center', marginLeft: '35px'},
      sortable: false
    },

  ]
  console.log(templateInfoData);
  return (
    <>
      <h2 className="text-2xl font-semibold text-title">Template Overview</h2>
      <div className="flex my-3 gap-x-2 justify-between items-center">
        <div className="basis-3/5">
          <div className="flex flex-row justify-between items-center gap-x-4 my-2">
            <div className="flex flex-col basis-3/5">
              <input type="text" placeholder="Search template" className="input input-bordered search-input-white focus:ring-0 focus:outline-none border-[#E6ECF2] font-normal text-14 text-muted w-full" onChange={handleSearch} />
            </div>
            <div className="flex flex-col basis-2/5">
              <FormControl fullWidth>
                <Autocomplete
                  options={options}
                  // eslint-disable-next-line @typescript-eslint/no-unsafe-return
                  getOptionLabel={(option) => option.label}
                  popupIcon={
                    <HugeiconsIcon
                      icon={ArrowDown01Icon}
                      size={18}
                      color="#3A3A3A"
                      strokeWidth={0.2}

                    />
                  }
                  value={selectedValue !== undefined ? selectedValue : ''}
                  onChange={(event, newValue) => handleTemplateValue(newValue)}
                  // disableClearable
                  // isOptionEqualToValue={(option, value) => option.value === value?.value}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      placeholder="Select Status"
                      variant="outlined"
                      sx={{
                        '& .MuiOutlinedInput-root': {
                          borderRadius: '40px',
                          height: '40px',
                          width: '200px', // Increased width
                        },
                      }}
                    />
                  )}
                  sx={{
                    '& .MuiAutocomplete-clearIndicator': {
                      marginRight: '-12px'
                    },
                    '& .MuiAutocomplete-input': {
                      width: '70%'
                    }
                  }}
                //disableClearable
                />
              </FormControl>
            </div>
          </div>
        </div>
        <div className="basis-2/5 justify-end flex">
          {checkEventPermission("TEMPLATE_ADD") &&
            <GradientButton color='red' onClick={handleAddTemplateClick}>
              <span style={{
                width: "20px",
                height: "20px",
                background: "#fff",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                borderRadius: "50px",
                marginRight: "5px"
              }}>
                <svg xmlns="http://www.w3.org/2000/svg" width="12" height="19" viewBox="0 0 19 19" fill="none">
                  <path d="M17.5411 10.3185H1.03183C0.467764 10.3185 0 9.85078 0 9.28671C0 8.72265 0.467764 8.25488 1.03183 8.25488H17.5411C18.1052 8.25488 18.573 8.72265 18.573 9.28671C18.573 9.85078 18.1052 10.3185 17.5411 10.3185Z" fill="#F13139" />
                  <path d="M9.28671 18.573C8.72265 18.573 8.25488 18.1052 8.25488 17.5411V1.03183C8.25488 0.467764 8.72265 0 9.28671 0C9.85078 0 10.3185 0.467764 10.3185 1.03183V17.5411C10.3185 18.1052 9.85078 18.573 9.28671 18.573Z" fill="#F13139" />
                </svg>
              </span>
              Add New Template
            </GradientButton>
          }
        </div>
      </div>
      <div className='data-table-container campaign-table mb-10 template-table-container'>
        <CustomDataTable
          // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
          columns={columns}
          data={templateSearchData}
          pagination
          // selectableRows
          progressPending={loading}
        />

        <MUIModal title='Add New Template' openModal={openAddTemplateModal} closeModal={handleCloseAddTemplateModal} width={'50%'} >
          <AddTemplateForm />
        </MUIModal>


        <BootstrapDialog
          onClose={handleDeleteTemplateClose}
          aria-labelledby="customized-dialog-title"
          open={showDeleteTemplateModal}
          PaperProps={{
            sx: {
              width: '550px',
              height: '200px'
            },
          }}
        >
          <DialogTitle sx={{ m: 0, p: 2, color: '#3A3A3A', fontSize: '18px', fontWeight: '600' }} id="customized-dialog-title">
            Delete Template
          </DialogTitle>

          <IconButton
            aria-label="close"
            onClick={handleDeleteTemplateClose}
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <HugeiconsIcon
              icon={MultiplicationSignStrokeStandard}
              size={24}
              color="currentcolor"
              strokeWidth={0.5}
            />

          </IconButton>
          <DialogContent>
            <p className='text-14 text-muted'>{ARE_YOU_SURE} {DELETE_TEMPLATE} <span className='font-semibold'>{templateInfoData?.templateName}</span>?</p>
          </DialogContent>
          <DialogActions sx={{ background: '#F9F9F9' }}>

            <OutlineButton color='gray' onClick={handleDeleteTemplateClose} width='100px'>Cancel</OutlineButton>

            <GradientButton type='button' color='red' onClick={handleDeleteTemplateConfirm} width='100px'>{!isModalSaveLoading ? 'Delete' : <span className="loading loading-spinner loading-xs text-white"></span>}</GradientButton>
          </DialogActions>
        </BootstrapDialog>

        <BootstrapDialog onClose={handleCopyTemplateClose} aria-labelledby="customized-dialog-title" open={showCopyTemplateModal} PaperProps={{ sx: { width: '550px', height: '200px' }, }}>
          <DialogTitle sx={{ m: 0, p: 2, color: '#3A3A3A', fontSize: '18px', fontWeight: '600' }} id="customized-dialog-title">
            Duplicate Template
          </DialogTitle>
          <IconButton aria-label="close" onClick={handleCopyTemplateClose} sx={{ position: 'absolute', right: 8, top: 8, color: (theme) => theme.palette.grey[500], }}>
            <HugeiconsIcon
              icon={MultiplicationSignStrokeStandard}
              size={24}
              color="currentcolor"
              strokeWidth={0.5}
            />

          </IconButton>
          <DialogContent>
            <p className='text-14 text-muted'>{ARE_YOU_SURE} {COPY_TEMPLATE} <span className='font-semibold'>{templateInfoData?.templateName}</span>?</p>
          </DialogContent>
          <DialogActions sx={{ background: '#F9F9F9' }}>
            <OutlineButton color='gray' onClick={handleCopyTemplateClose} width='100px'>Cancel</OutlineButton>
            <GradientButton type='button' color='red' onClick={handleCopyTemplateConfirm} width='100px'>{!isModalSaveLoading ? 'Duplicate' : <span className="loading loading-spinner loading-xs text-white"></span>}</GradientButton>
          </DialogActions>
        </BootstrapDialog>

        <BootstrapDialog onClose={handleupdatestatusClose} aria-labelledby="customized-dialog-title" open={showDeactivateTemplateModal} PaperProps={{ sx: { width: '550px', height: '300px' }, }}>
          <DialogTitle sx={{ m: 0, p: 2, color: '#3A3A3A', fontSize: '18px', fontWeight: '600' }} id="customized-dialog-title">
            {templateInfoData?.newStatus == 1 ? "Approve Template" : "Reject Template"}
          </DialogTitle>
          <IconButton aria-label="close" onClick={handleupdatestatusClose} sx={{ position: 'absolute', right: 8, top: 8, color: (theme) => theme.palette.grey[500], }}>
            <HugeiconsIcon
              icon={MultiplicationSignStrokeStandard}
              size={24}
              color="currentcolor"
              strokeWidth={0.5}
            />

          </IconButton>
          <DialogContent>
            <p className='text-14 text-muted'>{ARE_YOU_SURE}{" "}{templateInfoData?.newStatus == 1 ? "approve the template" : "reject the template"}{" "}<span className='font-semibold'>{templateInfoData?.templateName}</span>?</p>

            {/* Textarea instead of TextField */}
            <TextareaAutosize
              minRows={3}
              placeholder="Enter your comment"
              value={submitmessage}
              onChange={(e) => {
                setSubmitMessage(e.target.value);
                setValidationError(''); // Clear error on input
                setWarningMessage('');
              }}
              className="w-full border rounded-md p-2 mt-2"
              style={{
                borderColor: validationError ? 'red' : '#ccc',
                fontSize: '14px',
                width: '100%',
              }}
            />

            {/* Validation Message with More Space */}
            {validationError.length > 0 && (
              <div className="flex text-primary ml-1 mt-2 text-md font-normal">
                <img src="/assets/images/attention.svg" alt="Error" width={12} height={12} className="mr-1" />
                {validationError}
              </div>
            )}

            {/* Warning Message (Yellow) */}
            {warningMessage && (
              <div className="flex text-primary ml-1 mt-2 text-md font-normal">
                <img src="/assets/images/attention.svg" alt="Warning" width={12} height={12} className="mr-1" />
                {warningMessage}
              </div>
            )}
          </DialogContent>

          <BootstrapDialog
            onClose={() => setShowConfirmModal(false)}
            open={showConfirmModal}
            PaperProps={{
              sx: { width: "400px", height: "180px" },
            }}
          >

            <DialogTitle sx={{ m: 0, p: 2, color: '#3A3A3A', fontSize: '18px', fontWeight: '600' }} id="customized-dialog-title">
              Confirm Approval
            </DialogTitle>
            <DialogContent>
              <p className="text-14 text-muted">Are you sure you want to approve without any comment?</p>
            </DialogContent>
            <DialogActions sx={{ background: "#F9F9F9" }}>
              <OutlineButton color="gray" onClick={() => setShowConfirmModal(false)} width="130px">No</OutlineButton>
              <GradientButton type="button" color="red" onClick={proceedWithSubmission} width="130px">Yes</GradientButton>
            </DialogActions>
          </BootstrapDialog>
          <DialogActions sx={{ background: '#F9F9F9' }}>
            <OutlineButton color='gray' onClick={handleupdatestatusClose} width='130px'>Cancel</OutlineButton>
            <GradientButton type='button' color='red' onClick={handleUpdateStatusConfirm} width='130px'>{!isModalSaveLoading ? (templateInfoData?.newStatus == 1 ? "Approve" : "Reject") : (<span className="loading loading-spinner loading-xs text-white"></span>)}</GradientButton>
          </DialogActions>
        </BootstrapDialog>

        <BootstrapDialog onClose={handleSubmitForApprovalClose} aria-labelledby="customized-dialog-title" open={showSubmitForApprovalModal} PaperProps={{ sx: { width: '550px', height: '200px' }, }}>
          <DialogTitle sx={{ m: 0, p: 2, color: '#3A3A3A', fontSize: '18px', fontWeight: '600' }} id="customized-dialog-title">
            Submit for Approval
          </DialogTitle>
          <IconButton aria-label="close" onClick={handleSubmitForApprovalClose} sx={{ position: 'absolute', right: 8, top: 8, color: (theme) => theme.palette.grey[500], }}>
            <HugeiconsIcon
              icon={MultiplicationSignStrokeStandard}
              size={24}
              color="currentcolor"
              strokeWidth={0.5}
            />
          </IconButton>
          <DialogContent>
            <p className='text-14 text-muted'>{ARE_YOU_SURE}{" "}{"submit "}<span className='font-semibold'>{templateInfoData?.templateName}</span>{" for approval?"}</p>
          </DialogContent>
          <DialogActions sx={{ background: '#F9F9F9' }}>
            <OutlineButton color='gray' onClick={handleSubmitForApprovalClose} width='130px'>No</OutlineButton>
            <GradientButton type='button' color='red' onClick={handleSubmitForApprovalConfirm} width='130px'>{!isModalSaveLoading ? 'Yes' : <span className="loading loading-spinner loading-xs text-white"></span>}</GradientButton>
          </DialogActions>
        </BootstrapDialog>
        <TemplatePreview
          isOpen={isPreviewModalOpen}
          onClose={() => setIsPreviewModalOpen(false)}
          content={previewContent}
        />
      </div>
    </>
  );
};


export default TemplateList;
